import { render, staticRenderFns } from "./NewEnquiryMock.vue?vue&type=template&id=0442ac21&scoped=true"
import script from "./NewEnquiryMock.vue?vue&type=script&lang=js"
export * from "./NewEnquiryMock.vue?vue&type=script&lang=js"
import style0 from "./NewEnquiryMock.vue?vue&type=style&index=0&id=0442ac21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442ac21",
  null
  
)

export default component.exports